/* @flow */

export const minTargetSize = 48;

export const borderRadius = 4;
export const borderWidth = 1;
export const outlineWidth = 1;
